<template>
    <div
        class="PageBuilderVideo"
    >
        <flickity
            v-if="videos.length > 1"
            ref="flickity"
            :options="flickityOptions"
        >
            <div
                v-for="(video, index) in videos"
                :key="index"
                class="PageBuilderVideo__Slide">

                <div v-if="video.type == 'mp4'" class="PageBuilderVideo__video-wrap">
                    <video controls v-if="video.type == 'mp4'" :class="'video-' + index" class="invisible">
                        <source :src="video.data" type="video/mp4">
                    </video>
                    <button
                        :data-video="index"
                        class="PageBuilderVideo__icon">
                        <BaseIcon
                            icon="play-icon"
                            color="white"
                        />
                    </button>
                </div>

                <BaseVideo
                    v-else
                    :data="video.data"
                    :type="video.type"
                    :narrow="video.narrow"
                />
            </div>
        </flickity>

        <template
            v-else
        >
            <div v-if="videos[0].type == 'mp4'" class="PageBuilderVideo__video-wrap">
                <video controls v-if="videos[0].type == 'mp4'" :class="'video-' + index" class="invisible">
                    <source :src="videos[0].data" type="video/mp4">
                </video>
                <button
                    :data-video="index"
                    class="PageBuilderVideo__icon">
                    <BaseIcon
                        icon="play-icon"
                        color="white"
                    />
                </button>
            </div>

            <BaseVideo
                v-else
                :data="videos[0].data"
                :type="videos[0].type"
                :narrow="videos[0].narrow"
            />
        </template>

        <ul
            v-if="videos.length > 1"
            class="PageBuilderVideo__nav"
        >
            <ProgressiveCircle
                v-for="n in videos.length"
                :key="n"
                :index="n - 1"
                :activeSlide="activeSlide"
                @setActive="setActive"
            />
        </ul>
    </div>
</template>
<script>
import Flickity from './BaseCarousel.vue'

import { carouselProgressiveCircles } from '@mixins/carouselProgressiveCircles.js'

export default {
    name: 'PageBuilderVideo',
    mixins: [carouselProgressiveCircles],
    components: {
        Flickity
    },
    props: {
        videos: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            uniqId: Date.now(),
            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                autoPlay: true,
                selectedAttraction: 0.01,
                friction: 0.15
            },
        }
    },
    mounted() {
        if (this.videos.length > 1) {
            const carousel = document.querySelector('.PageBuilderVideo')
            const flkty = this.$refs.flickity.data(carousel)

            flkty.on('change', () => {
                this.selectActiveSlide(flkty)
            });
        }

        const playButtons = Array.from(document.querySelectorAll(".PageBuilderVideo__icon"));
        playButtons.forEach((btn) => {
            const video = document.querySelector(`.video-${btn.dataset.video}`);
            video.addEventListener('click', () => {
                btn.classList.add('hide');
            });
            video.addEventListener('loadeddata', () => {
                console.log('loaded')
                video.classList.remove('invisible');
            });
            btn.addEventListener('click', () => {
                video.play();
                btn.classList.add('hide');
            })
        });
    }
}
</script>
<style lang="scss" scoped>

    video {
        position: absolute;
        height: 100%;
        width: 100%;
    }

    .PageBuilderVideo__video-wrap {
        position: relative;
        padding-bottom: 53%;
        height: 0;
    }

    .PageBuilderVideo__Slide {
        padding-bottom: 53%;
        height: 0;
        width: 100%;

        .BaseVideo {
            position: absolute;
            height: 100%;
            width: 100%;
            padding-bottom:0;
        }

    }

    .PageBuilderVideo__nav {
        margin-top: getSpacing('spacer');
    }

    .PageBuilderVideo__icon {
        position: absolute;
        top: calc(50% - 30px);
        left: calc(50% - 30px);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        cursor: pointer;
        background: $action-color;
        border: 2px solid getColor('white');
        border-radius: 50%;
        transition: all ease-out 0.345s;
        font-size: 2rem;

        &:hover {
            background: getColor('blue', 'charcoal');
        }

        @include media-query(lap-and-up) {
            width: 100px;
            height: 100px;
            top: calc(50% - 50px);
            left: calc(50% - 50px);
            font-size: 3rem;
        }
    }

</style>
